export const groupsLong = [
  {
    title: 'For you',
    id: 1,
    type: 'default',
  },
  {
    title: 'Following',
    id: 2,
    type: 'default',
  },
  {
    title: 'Programming World',
    id: 3,
    type: 'technology',
  },
  {
    title: 'Front-End Developers',
    id: 4,
    type: 'technology',
  },
  {
    title: 'Language Learners',
    id: 5,
    type: 'education',
  },
  {
    title: 'Crypto Updates',
    id: 6,
    type: 'finance',
  },
  {
    title: 'Art-Lovers Community',
    id: 7,
    type: 'social',
  },
  {
    title: 'Real News Network',
    id: 8,
    type: 'news',
  },
  {
    title: 'Cat Owners',
    id: 9,
    type: 'social',
  },
  {
    title: 'Coffee Addicts',
    id: 10,
    type: 'social',
  },
  {
    title: 'Automobile Info',
    id: 11,
    type: 'engineering',
  },
  {
    title: 'Jazz Dispensary',
    id: 12,
    type: 'music',
  },
  {
    title: 'Two Wheelers',
    id: 13,
    type: 'social',
  },
  {
    title: 'Gamers Gamers',
    id: 14,
    type: 'entertainment',
  },
  {
    title: 'Political Headwind',
    id: 15,
    type: 'politics',
  },
  {
    title: 'How to center a Div?',
    id: 16,
    type: 'technology',
  },
]

export const groupsShort = [
  {
    title: 'For you',
    id: 1,
    type: 'default',
  },
  {
    title: 'Following',
    id: 2,
    type: 'default',
  },
]
